import react from "react";
import { Text, HStack, Link } from "@chakra-ui/react";
import { helpdeskUrl } from "services/config";
import ReportProblemIcon from "assets/images/ReportProblemIcon.png";
import { useTranslation } from "react-i18next";

export default function HelpdeskComponent() {
  const { t } = useTranslation();
  return (
    <Link href={helpdeskUrl} isExternal>
      <HStack>
        <img src={ReportProblemIcon} alt="" width="22px" height="20px" />
        <Text color="white" pb="2px" ml="4px !important">
          {t("Helpdesk_Report_a_Problem")}
        </Text>
      </HStack>
    </Link>
  );
}
